module.exports = __webpack_public_path__ + "1-10.png?345206de6d2cf151b8782ec752938d5b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-10.png
// module id = 87
// module chunks = 0